import React, { useState, useEffect } from "react"
import Box from "@material-ui/core/Box"
import Dialog from "@material-ui/core/Dialog"
import isEmpty from "lodash/isEmpty"
import PropTypes from "prop-types"
import { Form, FormSpy } from "react-final-form"
import { setPage, setSearch } from "src/features/Utils/mutators"
import { useSelector, useDispatch } from "react-redux"
import Search from "./Search"
import MedicineItem from "./MedicineItem"
import SupplyItem from "./SupplyItem"
import BundleItem from "./BundleItem"
import ShowTotal from "./ShowTotal"
import Paging from "./Pagination"
import { fetchList as fetchListSupply } from "src/pages/Supply/ducks"
import { fetchList as fetchListMedicine } from "src/pages/Medicine/ducks"
import { fetchList as fetchListBundle } from "src/pages/Bundle/List/ducks"
import useNotification from "src/features/Notification/customs"

const initialValues = {
  search_name: "",
  page: 1,
  limit: 5,
  // store searched fields in order to handle paging
  searched: {
    search_name: "",
  },
}

function MyDialog({ isOpen, handleClose }) {
  const [type, setType] = useState("medicine")
  const dispatch = useDispatch()
  const { showSuccess } = useNotification()
  // medicine
  const fetchingMedicine = useSelector((state) => state.medicine.fetching)
  const totalMedicine = useSelector((state) => state.medicine.total)
  const listMedicine = useSelector((state) => state.medicine.list)
  // supply
  const fetchingSupply = useSelector((state) => state.supply.fetching)
  const totalSupply = useSelector((state) => state.supply.total)
  const listSupply = useSelector((state) => state.supply.list)
  // bundle
  const fetchingBundle = useSelector((state) => state.bundle_list.fetching)
  const totalBundle = useSelector((state) => state.bundle_list.total)
  const listBundle = useSelector((state) => state.bundle_list.list)

  const handleFetchList = (values = initialValues) => {
    if (type === "medicine") {
      dispatch(fetchListMedicine(values))
    }
    if (type === "supply") {
      dispatch(fetchListSupply(values))
    }
    if (type === "bundle") {
      const newValues = { ...values, name: values.search_name }
      dispatch(fetchListBundle(newValues))
    }
  }

  // eslint-disable-next-line
  useEffect(() => {
    handleFetchList()
    // eslint-disable-next-line
  }, [type])

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values, form: { mutators } }) => {
        //check if in cart
        const inCart = (_id, type) =>
          values[type].find((item) => item._id === _id)
        // find index
        const findIndex = (_id, type) =>
          values[type].map((item) => item._id).indexOf(_id)

        const handleAddMedicine = (item) => (amount) => {
          mutators.addMedicine({ ...item, amount })
          showSuccess()
        }
        const handleUpdateMedicine = (_id) => (amount) => {
          mutators.updateMedicine(findIndex(_id, "medicine"), amount)
          showSuccess()
        }

        const handleAddSupply = (item) => (amount) => {
          mutators.addSupply({ ...item, amount })
          showSuccess()
        }
        const handleUpdateSupply = (_id) => (amount) => {
          mutators.updateSupply(findIndex(_id, "supply"), amount)
          showSuccess()
        }

        const handleAddBundle =
          ({ medicine = [], supply = [] }) =>
          () => {
            medicine.forEach((element) => {
              if (!isEmpty(element)) {
                if (
                  values.medicine
                    .map((mlist) => mlist._id)
                    .includes(element._id)
                ) {
                  const newAmount =
                    inCart(element._id, "medicine").amount + element.amount
                  mutators.updateMedicine(
                    findIndex(element._id, "medicine"),
                    newAmount
                  )
                } else {
                  mutators.addMedicine({ ...element })
                }
              }
            })
            supply.forEach((element) => {
              if (!isEmpty(element)) {
                if (
                  values.supply.map((slist) => slist._id).includes(element._id)
                ) {
                  const newAmount =
                    inCart(element._id, "supply").amount + element.amount
                  mutators.updateSupply(
                    findIndex(element._id, "supply"),
                    newAmount
                  )
                } else {
                  mutators.addSupply({ ...element })
                }
              }
            })
            showSuccess()
          }

        return (
          <Form
            initialValues={initialValues}
            onSubmit={({ searched, page, limit, ...values }, { mutators }) => {
              // values will be set in 'searched'
              mutators.setSearch(values)
              // reset page when search
              mutators.setPage(1)
              handleFetchList({ ...values, limit, page: 1 })
            }}
            mutators={{ setPage, setSearch }}
            subscription={{ submitting: true }}
          >
            {({ handleSubmit }) => (
              <Dialog
                open={isOpen}
                maxWidth="lg"
                onClose={handleClose}
                fullWidth
              >
                <Box bgcolor="#191C3A" pt={3} pb={4} pl={7}>
                  <Box fontSize="25px" color="#FFFFFFDE">
                    Sharmble Supermall
                  </Box>
                  <form onSubmit={handleSubmit}>
                    <Search
                      type={type}
                      onChangeType={(type) => setType(type)}
                    />
                  </form>
                </Box>
                <Box pb={3} pl={7} pr={7}>
                  <ShowTotal
                    total={
                      (type === "medicine" && totalMedicine) ||
                      (type === "supply" && totalSupply) ||
                      (type === "bundle" && totalBundle)
                    }
                    fetching={
                      fetchingMedicine || fetchingSupply || fetchingBundle
                    }
                    handleFetchList={handleFetchList}
                  />
                  <Box overflow="auto" whiteSpace="nowrap">
                    <Box minWidth="700px">
                      {type === "medicine" && (
                        <Box mt={2} minWidth="1184px">
                          {listMedicine.map((item, index) => (
                            <MedicineItem
                              key={item._id}
                              item={item}
                              action={
                                !!inCart(item._id, "medicine")
                                  ? handleUpdateMedicine(item._id)
                                  : handleAddMedicine(item)
                              }
                              inCart={inCart(item._id, "medicine")}
                            />
                          ))}
                        </Box>
                      )}
                      {type === "supply" && (
                        <Box mt={2} minWidth="1184px">
                          {listSupply.map((item, index) => (
                            <SupplyItem
                              key={item._id}
                              item={item}
                              action={
                                !!inCart(item._id, "supply")
                                  ? handleUpdateSupply(item._id)
                                  : handleAddSupply(item)
                              }
                              inCart={inCart(item._id, "supply")}
                            />
                          ))}
                        </Box>
                      )}
                      {type === "bundle" && (
                        <Box mt={2} minWidth="1184px">
                          {listBundle.map((item, index) => (
                            <BundleItem
                              key={item._id}
                              item={item}
                              action={handleAddBundle({
                                medicine: item.medicine,
                                supply: item.supply,
                              })}
                            />
                          ))}
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Paging
                    total={
                      (type === "medicine" && totalMedicine) ||
                      (type === "supply" && totalSupply) ||
                      (type === "bundle" && totalBundle)
                    }
                    onFetch={handleFetchList}
                  />
                </Box>
              </Dialog>
            )}
          </Form>
        )
      }}
    </FormSpy>
  )
}

MyDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default MyDialog
